import { render, staticRenderFns } from "./SidebarItems.vue?vue&type=template&id=a25f9922&"
import script from "./SidebarItems.vue?vue&type=script&lang=js&"
export * from "./SidebarItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports